import React, { useEffect, useState, Component } from 'react';
import { CheckCircle2, XCircle, ShieldCheck, Clock, CreditCard, BookOpen, FileText, Calendar, ListChecks, Star, ChevronDown, ChevronUp, ArrowRight, Gift, AlertCircle, Search, Hand, Sparkles, Apple, AlertTriangle, Target, ShoppingBag, X, Crown, Wind, Flame, Brain, RefreshCw } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/9MijnTaQhDwQnw7YUVK9ot/Untitled_design_(1).png';
const CHECKOUT_URL = 'https://checkout.tusbeneficios.shop/cart/50976043761897:1';
const CTAButton = ({
  text,
  className = ''
}: {
  text: string;
  className?: string;
}) => <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`w-full md:w-auto bg-amber-500 hover:bg-amber-400 text-emerald-950 font-bold text-lg py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(245,158,11,0.39)] hover:shadow-[0_6px_20px_rgba(245,158,11,0.23)] hover:-translate-y-1 transition-all duration-200 flex items-center justify-center gap-2 ${className}`} data-id="element-0">
    {text}
    <ArrowRight className="w-5 h-5" data-id="element-1" />
  </a>;
const AccordionCard = ({
  number,
  label,
  title,
  icon: Icon,
  description,
  bullets = [],
  priceValue,
  isOpenDefault = false,
  accent = 'emerald'
}: {
  number: string | number;
  label: string;
  title: string;
  icon: any;
  description: string;
  bullets?: string[];
  priceValue?: string;
  isOpenDefault?: boolean;
  accent?: 'emerald' | 'amber';
}) => {
  const [isOpen, setIsOpen] = useState(isOpenDefault);
  // "amber" accent now renders as a soft "verde agua" (teal) for the bonos
  const isAqua = accent === 'amber';
  const cardBorder = isAqua ? 'border-teal-200 bg-teal-50/50' : 'border-emerald-100 bg-white';
  const tileBg = isAqua ? 'bg-teal-400' : 'bg-emerald-500';
  const badgeBg = isAqua ? 'bg-teal-700' : 'bg-emerald-950';
  const labelColor = isAqua ? 'text-teal-600' : 'text-emerald-600';
  const chevronColor = isAqua ? 'text-teal-600' : 'text-emerald-600';
  const quoteBorder = isAqua ? 'border-teal-300' : 'border-emerald-300';
  const bulletColor = isAqua ? 'text-teal-500' : 'text-emerald-400';
  return <div className={`rounded-2xl shadow-sm border overflow-hidden mb-4 last:mb-0 ${cardBorder}`} data-id="element-2">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full p-4 md:p-5 flex items-center gap-4 text-left focus:outline-none" data-id="element-3">
        <div className={`relative text-white w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${tileBg}`} data-id="element-4">
          <Icon className="w-6 h-6" data-id="element-5" />
          <div className={`absolute -top-2 -right-2 text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center border-2 border-white ${badgeBg}`} data-id="element-6">
            {number}
          </div>
        </div>
        <div className="flex-1 pr-2" data-id="element-7">
          <p className={`text-xs font-bold mb-0.5 tracking-wider uppercase ${labelColor}`} data-id="element-8">
            {label}
          </p>
          <h4 className="font-bold text-lg md:text-xl text-emerald-950 leading-tight" data-id="element-9">
            {title}
          </h4>
        </div>
        <div className="bg-white border border-slate-100 p-2 rounded-full flex-shrink-0" data-id="element-10">
          {isOpen ? <ChevronUp className={`w-5 h-5 ${chevronColor}`} data-id="element-11" /> : <ChevronDown className={`w-5 h-5 ${chevronColor}`} data-id="element-12" />}
        </div>
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-13">
        <div className="p-4 md:p-5 pt-0 mt-2" data-id="element-14">
          <p className={`text-gray-600 italic border-l-2 pl-3 mb-4 text-sm md:text-base ${quoteBorder}`} data-id="element-15">
            "{description}"
          </p>

          {bullets.length > 0 && <div className="space-y-2 mb-4" data-id="element-16">
              {bullets.map((bullet, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-17">
                  <CheckCircle2 className={`w-4 h-4 mt-0.5 flex-shrink-0 ${bulletColor}`} data-id="element-18" />
                  <span className="text-sm text-gray-700" data-id="element-19">{bullet}</span>
                </div>)}
            </div>}

          {priceValue && <div className="flex items-center gap-3 mt-4 pt-4 border-t border-teal-200/60" data-id="element-20">
              <span className="text-sm font-medium text-slate-400 line-through" data-id="element-21">
                Valor: {priceValue}
              </span>
              <span className="bg-teal-400 text-teal-950 text-sm font-extrabold px-3 py-1 rounded-md" data-id="element-22">
                HOY GRATIS
              </span>
            </div>}
        </div>
      </div>
    </div>;
};
const OFFER_PLANS = [{
  id: 'basico',
  name: 'SISTEMA TAI CHI LIVIANO',
  detail: '6 módulos + 3 bonos estratégicos',
  oldPrice: '$34.990',
  price: '$19.990',
  highlight: false,
  savings: null as string | null,
  cta: 'Quiero el Sistema Tai Chi',
  checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/50976043761897:1'
}, {
  id: 'completo',
  name: 'PACK COMPLETO',
  detail: '6 módulos + 3 bonos + Acceso Pro Élite',
  oldPrice: '$43.990',
  price: '$27.990',
  highlight: true,
  savings: 'AHORRÁS $15.000',
  cta: 'Sí, quiero el Pack Completo',
  checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51156005028073:1'
}];
const OfferCountdown = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const Unit = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-23">
      <div className="bg-emerald-900 border border-emerald-700 rounded-lg w-16 h-14 flex items-center justify-center text-3xl font-black text-white" data-id="element-24">
        {value}
      </div>
      <span className="text-[10px] tracking-widest text-emerald-300/70 mt-1 uppercase" data-id="element-25">
        {label}
      </span>
    </div>;
  return <div className="flex items-center gap-2" data-id="element-26">
      <Unit value={hours} label="Horas" data-id="element-27" />
      <span className="text-2xl font-black text-emerald-500 pb-4" data-id="element-28">:</span>
      <Unit value={minutes} label="Min" data-id="element-29" />
      <span className="text-2xl font-black text-emerald-500 pb-4" data-id="element-30">:</span>
      <Unit value={seconds} label="Seg" data-id="element-31" />
    </div>;
};
const OfferSelector = () => {
  const [selected, setSelected] = useState('completo');
  const active = OFFER_PLANS.find(p => p.id === selected) ?? OFFER_PLANS[1];
  return <div className="max-w-md mx-auto" data-id="element-32">
      <h2 className="text-3xl md:text-4xl font-extrabold mb-2 text-center" data-id="element-33">
        ELEGÍ TU <span className="text-amber-400" data-id="element-34">PACK IDEAL</span>
      </h2>
      <p className="text-emerald-200/80 text-center mb-6" data-id="element-35">
        Ambas opciones incluyen los bonos gratis completos.
      </p>

      <div className="space-y-3 mb-6" data-id="element-36">
        {OFFER_PLANS.map(plan => {
        const isActive = selected === plan.id;
        return <button key={plan.id} onClick={() => setSelected(plan.id)} className={`w-full text-left rounded-2xl p-4 border-2 transition-all duration-200 ${isActive ? 'border-amber-400 bg-emerald-900' : 'border-emerald-800 bg-emerald-900/40 hover:border-emerald-600'}`} data-id="element-37">
              <div className="flex items-start gap-3" data-id="element-38">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isActive ? 'border-amber-400' : 'border-emerald-600'}`} data-id="element-39">
                  {isActive && <div className="w-2.5 h-2.5 rounded-full bg-amber-400" data-id="element-40" />}
                </div>

                <div className="flex-1" data-id="element-41">
                  <div className="flex items-center justify-between gap-2" data-id="element-42">
                    <span className="font-bold text-white text-base" data-id="element-43">
                      {plan.name}
                    </span>
                    <div className="text-right" data-id="element-44">
                      <span className="block text-xs text-emerald-300/70 line-through leading-none" data-id="element-45">
                        {plan.oldPrice}
                      </span>
                      <span className="block text-xl font-black text-amber-400 leading-tight" data-id="element-46">
                        {plan.price}
                      </span>
                    </div>
                  </div>

                  {plan.highlight && <div className="flex flex-wrap gap-2 mt-2" data-id="element-47">
                      <span className="inline-flex items-center gap-1 bg-amber-400 text-amber-950 text-[11px] font-bold px-2 py-0.5 rounded" data-id="element-48">
                        <Star className="w-3 h-3 fill-current" data-id="element-49" /> MÁS ELEGIDO
                      </span>
                      {plan.savings && <span className="bg-emerald-500 text-white text-[11px] font-bold px-2 py-0.5 rounded" data-id="element-50">
                          {plan.savings}
                        </span>}
                    </div>}

                  <p className="text-xs text-emerald-200/70 mt-2" data-id="element-51">
                    {plan.detail}
                  </p>
                </div>
              </div>
            </button>;
      })}
      </div>

      <a href={active.checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full bg-amber-500 hover:bg-amber-400 text-emerald-950 font-bold text-lg py-5 px-6 rounded-2xl shadow-[0_4px_14px_0_rgba(245,158,11,0.39)] hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2 uppercase" data-id="element-52">
        {active.cta}
        <ArrowRight className="w-5 h-5" data-id="element-53" />
      </a>

      <p className="text-center text-sm text-emerald-200/60 italic mt-4" data-id="element-54">
        La opción más elegida por quienes buscan resultados reales.
      </p>

      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-6 pt-6 border-t border-emerald-800 text-sm text-emerald-200/80 font-medium" data-id="element-55">
        <span className="flex items-center gap-1.5" data-id="element-56">
          <CreditCard className="w-4 h-4" data-id="element-57" /> Pago seguro
        </span>
        <span className="flex items-center gap-1.5" data-id="element-58">
          <Clock className="w-4 h-4" data-id="element-59" /> Acceso inmediato
        </span>
        <span className="flex items-center gap-1.5" data-id="element-60">
          <ShieldCheck className="w-4 h-4" data-id="element-61" /> Garantía 7 días
        </span>
      </div>
    </div>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-emerald-100 last:border-0" data-id="element-62">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-63">
        <span className="font-semibold text-emerald-900 text-lg" data-id="element-64">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-emerald-600" data-id="element-65" /> : <ChevronDown className="w-5 h-5 text-emerald-600" data-id="element-66" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-40 pb-4' : 'max-h-0'}`} data-id="element-67">
        <p className="text-gray-600" data-id="element-68">{answer}</p>
      </div>
    </div>;
};
// Countdown Timer Component
// Shared 24h countdown hook
const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          seconds = 59;
          minutes--;
        } else if (hours > 0) {
          seconds = 59;
          minutes = 59;
          hours--;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return {
    hours: pad(timeLeft.hours),
    minutes: pad(timeLeft.minutes),
    seconds: pad(timeLeft.seconds)
  };
};
const CountdownBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 bg-emerald-950 border-b-2 border-amber-500 text-white py-2 px-4 text-center text-sm font-medium shadow-md" data-id="element-69">
      <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-70">
        <AlertCircle className="w-4 h-4 animate-pulse" data-id="element-71" />
        <span className="font-semibold text-amber-400" data-id="element-72">
          ¡Oferta termina en:
        </span>
        <div className="flex gap-1 font-mono font-bold" data-id="element-73">
          <span className="bg-amber-500 text-emerald-950 px-2 py-0.5 rounded" data-id="element-74">
            {hours}h
          </span>
          <span className="bg-amber-500 text-emerald-950 px-2 py-0.5 rounded" data-id="element-75">
            {minutes}m
          </span>
          <span className="bg-amber-500 text-emerald-950 px-2 py-0.5 rounded" data-id="element-76">
            {seconds}s
          </span>
        </div>
      </div>
    </div>;
};
// Purchase notification toast
const PurchaseNotification = () => {
  const buyers = [{
    name: 'Lucas',
    city: 'Buenos Aires'
  }, {
    name: 'Martina',
    city: 'Córdoba'
  }, {
    name: 'Federico',
    city: 'Rosario'
  }, {
    name: 'Camila',
    city: 'Mendoza'
  }, {
    name: 'Joaquín',
    city: 'La Plata'
  }, {
    name: 'Valentina',
    city: 'Mar del Plata'
  }, {
    name: 'Mateo',
    city: 'Tucumán'
  }, {
    name: 'Sofía',
    city: 'Salta'
  }, {
    name: 'Tomás',
    city: 'Neuquén'
  }, {
    name: 'Agustín',
    city: 'San Juan'
  }];
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(buyers[0]);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    const showNotification = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrent(buyer);
      setMinutesAgo(Math.floor(Math.random() * 8) + 1);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showNotification, 4000);
    const interval = setInterval(showNotification, 14000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs bg-white rounded-2xl shadow-2xl border border-emerald-100 p-4 transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-77">
      <div className="flex items-start gap-3" data-id="element-78">
        <div className="bg-emerald-100 text-emerald-600 p-2 rounded-full flex-shrink-0" data-id="element-79">
          <ShoppingBag className="w-5 h-5" data-id="element-80" />
        </div>
        <div className="flex-1" data-id="element-81">
          <p className="text-sm font-semibold text-emerald-950" data-id="element-82">
            {current.name} de {current.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-83">
            acaba de comprar Sistema Tai Chi Liviano
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-84">hace {minutesAgo} min</p>
        </div>
        <button onClick={() => setVisible(false)} className="text-gray-300 hover:text-gray-500" aria-label="Cerrar" data-id="element-85">
          <X className="w-4 h-4" data-id="element-86" />
        </button>
      </div>
    </div>;
};
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-amber-200 selection:text-emerald-900" data-id="element-87">
      <CountdownBar data-id="element-88" />
      <PurchaseNotification data-id="element-89" />

      {/* 1. HERO SECTION */}
      <section className="bg-emerald-950 text-white pt-8 pb-12 px-4 relative overflow-hidden" data-id="element-90">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-91">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-emerald-500 blur-3xl" data-id="element-92"></div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10 text-center space-y-4" data-id="element-93">
          <div className="inline-block bg-emerald-800/50 border border-emerald-700 text-amber-400 font-semibold px-4 py-1 rounded-full text-xs" data-id="element-94">
            NUEVO MÉTODO 2026
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight" data-id="element-95">
            ¡Bajá de peso desde tu silla en{' '}
            <span className="text-amber-400" data-id="element-96">30 días</span> sin impacto ni
            esfuerzo!
          </h1>

          {/* Mockup between title and subtitle */}
          <div className="relative mx-auto w-full max-w-[280px]" data-id="element-97">
            <div className="absolute inset-0 bg-amber-500/20 blur-3xl rounded-full transform scale-90" data-id="element-98"></div>
            <img src={PRODUCT_IMAGE} alt="Sistema Tai Chi Liviano" className="relative z-10 w-full h-auto drop-shadow-2xl animate-float" data-id="element-99" />
          </div>

          <p className="text-base md:text-lg text-emerald-100 max-w-2xl mx-auto" data-id="element-100">
            Un método único que combina los movimientos suaves del Tai Chi con
            la comodidad de tu silla para ayudarte a bajar de peso, mejorar tu
            salud y sentirte con más energía.
          </p>

          <div className="pt-2 flex flex-col items-center space-y-3" data-id="element-101">
            <div className="flex flex-wrap justify-center gap-4 text-sm text-emerald-200/80 font-medium" data-id="element-102">
              <div className="flex items-center gap-1.5" data-id="element-103">
                <Clock className="w-4 h-4" data-id="element-104" /> Acceso inmediato
              </div>
              <div className="flex items-center gap-1.5" data-id="element-105">
                <CreditCard className="w-4 h-4" data-id="element-106" /> Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-107">
                <ShieldCheck className="w-4 h-4" data-id="element-108" /> Garantía 7 días
              </div>
            </div>

            <CTAButton text="Quiero mi Sistema ahora" className="text-xl px-10 py-5" data-id="element-109" />

            {/* Guarantee + social proof (ref image) */}
            <div className="w-full max-w-md mt-1 space-y-3" data-id="element-110">
              <div className="flex items-start justify-center gap-2 text-emerald-100/90 text-sm" data-id="element-111">
                <ShieldCheck className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-112" />
                <span data-id="element-113">
                  Garantía 7 días. Si no notás cambios, te devolvemos el dinero.
                </span>
              </div>

              <div className="bg-emerald-900/60 border border-emerald-800 rounded-2xl p-4 flex items-center justify-center gap-4" data-id="element-114">
                <div className="flex gap-0.5 text-amber-400 flex-shrink-0" data-id="element-115">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-116" />)}
                </div>
                <p className="text-sm text-emerald-100/90 font-medium text-left" data-id="element-117">
                  <span className="font-bold text-white" data-id="element-118">4.9</span> — +1.200
                  personas ya transformaron su cuerpo desde casa
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 1.5 PRUEBA SOCIAL (MOVED UP) */}
      <section className="py-14 px-4 bg-white" data-id="element-119">
        <div className="max-w-5xl mx-auto" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold text-emerald-950 text-center mb-8" data-id="element-121">
            Personas reales, resultados reales
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-122">
            {[{
            name: 'Marta G.',
            text: 'En 2 semanas noté que la ropa me queda más holgada. Es increíble lo fácil que es hacer los ejercicios sentada.'
          }, {
            name: 'Silvia S.',
            text: 'Por fin encontré algo que no me lastima las rodillas. Me siento con mucha más energía y vitalidad.'
          }, {
            name: 'Elena M.',
            text: 'Es simple y relajante. Las rutinas guiadas me salvaron porque no me gusta ir al gimnasio.'
          }].map((testimonial, i) => <div key={i} className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-123">
                <div className="flex gap-1 text-amber-400 mb-4" data-id="element-124">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-125" />)}
                </div>
                <p className="text-gray-700 italic mb-4" data-id="element-126">
                  "{testimonial.text}"
                </p>
                <p className="font-bold text-emerald-900" data-id="element-127">{testimonial.name}</p>
                <p className="text-xs text-gray-500" data-id="element-128">Comprador verificado</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 2. IDENTIFICACIÓN DEL PROBLEMA */}
      <section className="py-14 px-4 bg-emerald-950 text-white" data-id="element-129">
        <div className="max-w-3xl mx-auto" data-id="element-130">
          <div className="text-center mb-10" data-id="element-131">
            <h2 className="text-3xl md:text-4xl font-bold inline-block relative" data-id="element-132">
              ¿Te está pasando esto?
              <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-red-500 rounded-full" data-id="element-133"></div>
            </h2>
          </div>

          <div className="space-y-3" data-id="element-134">
            {['Te cuesta bajar de peso y las dietas estrictas no te funcionan', 'Sentís dolor en las rodillas o articulaciones al hacer ejercicio', 'Te falta energía y te sentís pesada durante el día', 'Probaste rutinas de alto impacto y terminaste abandonando', 'Pasás mucho tiempo sentada y no sabés cómo activarte', 'El estrés y la ansiedad te llevan a comer de más'].map((item, i) => <div key={i} className="bg-emerald-900/50 border border-emerald-800 rounded-2xl p-5 flex items-center gap-4" data-id="element-135">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-136" />
                <p className="text-emerald-50 font-medium" data-id="element-137">{item}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 3. CALIFICACIÓN */}
      <section className="py-14 px-4 bg-slate-50" data-id="element-138">
        <div className="max-w-3xl mx-auto" data-id="element-139">
          <div className="text-center mb-10" data-id="element-140">
            <h2 className="text-3xl md:text-4xl font-bold text-emerald-950 inline-block relative" data-id="element-141">
              Esto es para vos si...
              <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-emerald-500 rounded-full" data-id="element-142"></div>
            </h2>
          </div>

          <div className="space-y-3" data-id="element-143">
            {['Querés bajar de peso de forma natural y sin saltos', 'Buscás una rutina suave que proteja tus articulaciones', 'Preferís hacer ejercicio desde la comodidad de tu casa', 'Necesitás un método paso a paso, fácil de seguir', 'Querés mejorar tu postura, flexibilidad y reducir el estrés', 'Buscás resultados reales sin matarte en el gimnasio'].map((item, i) => <div key={i} className="bg-white border border-slate-200 rounded-2xl p-5 flex items-center gap-4 shadow-sm" data-id="element-144">
                <CheckCircle2 className="w-6 h-6 text-emerald-500 flex-shrink-0" data-id="element-145" />
                <p className="text-emerald-950 font-medium" data-id="element-146">{item}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. STATS / BADGE CARD (MOVED ABOVE TOMOS) */}
      <section className="pt-14 pb-4 px-4 bg-white" data-id="element-147">
        <div className="max-w-3xl mx-auto" data-id="element-148">
          <div className="bg-emerald-600 rounded-[1.5rem] p-6 md:p-8 text-center text-white shadow-lg relative overflow-hidden" data-id="element-149">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-48 h-48 bg-emerald-500 rounded-full mix-blend-multiply filter blur-2xl opacity-50 transform translate-x-1/2 -translate-y-1/2" data-id="element-150"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-emerald-700 rounded-full mix-blend-multiply filter blur-2xl opacity-50 transform -translate-x-1/2 translate-y-1/2" data-id="element-151"></div>

            <div className="relative z-10" data-id="element-152">
              <div className="inline-flex items-center gap-2 bg-emerald-500/30 border border-emerald-400/30 text-white font-bold px-3 py-1 rounded-full text-xs mb-6" data-id="element-153">
                <CheckCircle2 className="w-3.5 h-3.5" data-id="element-154" />
                MÉTODO N°1 EN ARGENTINA
              </div>

              <div className="flex flex-row items-center justify-center gap-8 md:gap-16 mb-6" data-id="element-155">
                <div data-id="element-156">
                  <div className="text-4xl md:text-5xl font-black mb-0.5" data-id="element-157">
                    6
                  </div>
                  <div className="text-emerald-100 font-medium tracking-widest uppercase text-xs" data-id="element-158">
                    Tomos
                  </div>
                </div>
                <div className="w-px h-12 bg-emerald-500/50" data-id="element-159"></div>
                <div data-id="element-160">
                  <div className="text-4xl md:text-5xl font-black mb-0.5" data-id="element-161">
                    +36
                  </div>
                  <div className="text-emerald-100 font-medium tracking-widest uppercase text-xs" data-id="element-162">
                    Guías
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap justify-center gap-2" data-id="element-163">
                {['Diagnóstico', 'Frenar la caída', 'Estimulación', 'Alimentación', 'Errores', 'Plan completo'].map((tag, i) => <span key={i} className="bg-emerald-500/40 border border-emerald-400/30 text-white px-3 py-1.5 rounded-full text-xs font-medium" data-id="element-164">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. QUÉ INCLUYE EL KIT */}
      <section className="py-14 px-4 bg-white" data-id="element-165">
        <div className="max-w-5xl mx-auto" data-id="element-166">
          <div className="text-center mb-10" data-id="element-167">
            <h2 className="text-3xl md:text-4xl font-bold text-emerald-950 mb-4" data-id="element-168">
              ¿Qué incluye tu acceso hoy?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-169">
              Todo lo que necesitás en un solo lugar, formato digital de acceso
              inmediato.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-10" data-id="element-170">
            {[{
            icon: BookOpen,
            title: '6 Tomos Principales'
          }, {
            icon: FileText,
            title: '+36 Guías Prácticas'
          }, {
            icon: Calendar,
            title: 'Plan de 60 Días'
          }, {
            icon: ListChecks,
            title: 'Rutinas Paso a Paso'
          }].map((item, i) => <div key={i} className="bg-slate-50 rounded-xl px-3 py-4 text-center border border-slate-200 hover:border-emerald-300 transition-colors flex flex-col items-center gap-2" data-id="element-171">
                <div className="bg-white w-11 h-11 rounded-full flex items-center justify-center shadow-sm text-emerald-600" data-id="element-172">
                  <item.icon className="w-5 h-5" data-id="element-173" />
                </div>
                <h3 className="font-bold text-sm text-emerald-950 leading-tight" data-id="element-174">
                  {item.title}
                </h3>
              </div>)}
          </div>

          {/* TOMOS DETAIL (ACCORDION) */}
          <div className="border-t border-slate-200 pt-12" data-id="element-175">
            <div className="text-center mb-8" data-id="element-176">
              <h3 className="text-2xl md:text-3xl font-bold text-emerald-950 mb-2" data-id="element-177">
                Conocé los 6 Tomos del sistema
              </h3>
              <p className="text-gray-600" data-id="element-178">
                Todo lo que vas a aprender, paso a paso.
              </p>
            </div>

            <div className="max-w-2xl mx-auto" data-id="element-179">
              <AccordionCard number="1" label="TOMO 1" title="Despertá tu Cuerpo" icon={Wind} description="Introducción al Sistema Tai Chi Liviano. Ideal para quienes nunca hicieron Tai Chi en su vida." bullets={['Cómo funciona el método y por qué el movimiento suave activa el metabolismo', 'Preparación de tu cuerpo y tu mente antes de empezar', 'Primeros pasos sin experiencia previa']} isOpenDefault={true} data-id="element-180" />
              <AccordionCard number="2" label="TOMO 2" title="Movimientos que Sanan" icon={Hand} description="Las primeras secuencias de movimientos sentado, paso a paso, con descripciones claras y simples." bullets={['Activá la circulación desde la silla', 'Soltá la tensión muscular acumulada', 'Empezá a mover la energía estancada']} data-id="element-181" />
              <AccordionCard number="3" label="TOMO 3" title="Quemá sin Sufrir" icon={Flame} description="Rutinas progresivas diseñadas para acelerar el metabolismo sin impacto articular. Acá el cuerpo empieza a cambiar." bullets={['Combinaciones de respiración + movimiento', 'Progresión segura sin impacto en las articulaciones', 'Maximizá los resultados en cada sesión']} data-id="element-182" />
              <AccordionCard number="4" label="TOMO 4" title="Comé Liviano, Vivé Liviano" icon={Apple} description="Guía de alimentación adaptada al método. Sin dietas extremas ni contar calorías." bullets={['Alimentos antiinflamatorios accesibles', 'Hábitos simples para el día a día', 'Tips concretos para el argentino promedio']} data-id="element-183" />
              <AccordionCard number="5" label="TOMO 5" title="La Mente que Adelgaza" icon={Brain} description="El componente mental del sistema. Estrés, cortisol y ansiedad son las causas ocultas del sobrepeso." bullets={['Técnicas de respiración para bajar el cortisol', 'Meditación en movimiento', 'Reprogramación de hábitos']} data-id="element-184" />
              <AccordionCard number="6" label="TOMO 6" title="Tu Nuevo Estilo de Vida" icon={RefreshCw} description="El plan de mantenimiento. Cómo sostener los resultados en el tiempo." bullets={['Qué hacer cuando te estancás', 'Cómo incorporar el Tai Chi Liviano de forma permanente', 'Rutina diaria sostenible']} data-id="element-185" />
            </div>
          </div>
        </div>
      </section>

      {/* 6. BONOS */}
      <section className="py-14 px-4 bg-teal-50/60" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <div className="text-center mb-8" data-id="element-188">
            <div className="inline-flex items-center gap-2 bg-teal-400 text-teal-950 font-extrabold px-5 py-2 rounded-full mb-4 shadow-sm" data-id="element-189">
              <Gift className="w-5 h-5" data-id="element-190" />
              REGALOS EXCLUSIVOS HOY
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-emerald-950" data-id="element-191">
              Llevate estos 3 Bonos{' '}
              <span className="text-teal-500" data-id="element-192">100% GRATIS</span>
            </h2>
            <p className="text-teal-700 font-semibold mt-2" data-id="element-193">
              Valorados en $37.000 — incluidos sin costo con tu compra de hoy
            </p>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-194">
            <AccordionCard number="1" label="BONO 1 — GRATIS" title="Guía de Inicio Rápido" icon={Gift} accent="amber" description="Para los que quieren empezar hoy mismo." bullets={['Hoja de ruta de una sola página', 'Los 5 movimientos esenciales del sistema', 'Rutina de 10 minutos lista para hacer']} priceValue="$15.000" isOpenDefault={true} data-id="element-195" />
            <AccordionCard number="2" label="BONO 2 — GRATIS" title="Calendario de 28 Días" icon={Gift} accent="amber" description="Un plan día a día que combina los 6 tomos en una secuencia lógica y progresiva." bullets={['Sabés exactamente qué hacer cada día', 'Secuencia progresiva sin tener que pensar', 'Imprimible y descargable']} priceValue="$10.000" data-id="element-196" />
            <AccordionCard number="3" label="BONO 3 — GRATIS" title="Recetario Liviano Argentino" icon={Gift} accent="amber" description="20 recetas antiinflamatorias adaptadas a la cocina argentina." bullets={['Sin ingredientes raros ni costosos', 'Pensado para que comer sano no sea un sacrificio', 'Recetas simples del día a día']} priceValue="$12.000" data-id="element-197" />
          </div>
        </div>
      </section>

      {/* 7.5 COMPARISON TABLE */}
      <section className="py-14 px-4 bg-slate-50" data-id="element-198">
        <div className="max-w-4xl mx-auto" data-id="element-199">
          <div className="text-center mb-10" data-id="element-200">
            <h2 className="text-3xl md:text-4xl font-bold text-emerald-950 inline-block relative" data-id="element-201">
              Tu situación hoy vs. con Sistema Tai Chi Liviano
              <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-emerald-500 rounded-full" data-id="element-202"></div>
            </h2>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden" data-id="element-203">
            {/* Header */}
            <div className="grid grid-cols-2" data-id="element-204">
              <div className="p-6 text-center bg-slate-50 border-b border-r border-slate-200" data-id="element-205">
                <h3 className="text-xl font-bold text-slate-500" data-id="element-206">
                  Sin el Sistema
                </h3>
              </div>
              <div className="p-6 text-center bg-emerald-950 border-b border-emerald-950" data-id="element-207">
                <h3 className="text-xl font-bold text-emerald-400" data-id="element-208">
                  Con el Sistema
                </h3>
              </div>
            </div>

            {/* Rows */}
            {[{
            bad: 'Hacés ejercicios que te lastiman',
            good: 'Movimientos suaves y seguros'
          }, {
            bad: 'Dietas restrictivas que abandonás',
            good: 'Pérdida de peso natural'
          }, {
            bad: 'Estrés y ansiedad constantes',
            good: 'Mente en calma y relajada'
          }, {
            bad: 'Falta de energía diaria',
            good: 'Vitalidad y bienestar general'
          }, {
            bad: 'No sabés por dónde empezar',
            good: 'Rutina clara paso a paso'
          }].map((row, i) => <div key={i} className="grid grid-cols-2 border-b border-slate-100 last:border-0" data-id="element-209">
                <div className="p-4 md:p-6 flex items-center gap-3 border-r border-slate-100 bg-slate-50/50" data-id="element-210">
                  <div className="bg-red-100 p-1.5 rounded-full flex-shrink-0" data-id="element-211">
                    <X className="w-4 h-4 text-red-500" data-id="element-212" />
                  </div>
                  <p className="text-sm md:text-base text-slate-600 font-medium" data-id="element-213">
                    {row.bad}
                  </p>
                </div>
                <div className="p-4 md:p-6 flex items-center gap-3 bg-white" data-id="element-214">
                  <div className="bg-emerald-100 p-1.5 rounded-full flex-shrink-0" data-id="element-215">
                    <CheckCircle2 className="w-4 h-4 text-emerald-600" data-id="element-216" />
                  </div>
                  <p className="text-sm md:text-base text-emerald-950 font-bold" data-id="element-217">
                    {row.good}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. OFERTA */}
      <section className="py-14 px-4 bg-emerald-950 text-white relative" data-id="element-218">
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-219">
          <div className="flex flex-col items-center gap-3 mb-8" data-id="element-220">
            <div className="flex items-center gap-2 text-amber-400 font-bold" data-id="element-221">
              <Clock className="w-5 h-5 animate-pulse" data-id="element-222" />
              <span className="uppercase tracking-wide text-sm" data-id="element-223">
                Esta oferta termina en
              </span>
            </div>
            <OfferCountdown data-id="element-224" />
          </div>

          <OfferSelector data-id="element-225" />
        </div>
      </section>

      {/* 8.5 KIT vs ELITE COMPARISON */}
      <section className="py-14 px-4 bg-white" data-id="element-226">
        <div className="max-w-2xl mx-auto" data-id="element-227">
          <div className="text-center mb-10" data-id="element-228">
            <h2 className="text-3xl md:text-4xl font-bold text-emerald-950" data-id="element-229">
              ¿Qué vas a obtener con el{' '}
              <span className="text-teal-500" data-id="element-230">PACK COMPLETO</span>?
            </h2>
            <p className="text-gray-600 mt-3" data-id="element-231">
              La diferencia entre bajar de peso y transformar tu cuerpo y mente
              por completo.
            </p>
          </div>

          {/* Card 1: Solo Kit */}
          <div className="bg-slate-50 border border-slate-200 rounded-2xl p-6 mb-5" data-id="element-232">
            <div className="inline-flex items-center gap-2 bg-slate-200 text-slate-600 font-bold px-3 py-1 rounded-full text-xs mb-4 uppercase tracking-wide" data-id="element-233">
              Si tenés solo Sistema Tai Chi Liviano
            </div>
            <h3 className="text-xl font-bold text-slate-700 mb-4" data-id="element-234">
              Bajás de peso y mejorás tu movilidad
            </h3>
            <ul className="space-y-3" data-id="element-235">
              {['Solo acceso al método principal', 'No incluye estrategias avanzadas de meditación', 'No incluye guía específica de nutrición antiinflamatoria', 'No incluye recursos para mejorar tu flexibilidad avanzada'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-236">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-237" />
                  <span className="text-slate-600" data-id="element-238">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Card 2: Elite (recommended) */}
          <div className="relative bg-emerald-950 border-2 border-teal-400 rounded-2xl p-6 pt-8 shadow-xl" data-id="element-239">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 bg-teal-400 text-emerald-950 font-extrabold px-4 py-1 rounded-full text-xs uppercase tracking-wide shadow" data-id="element-240">
              <Crown className="w-3.5 h-3.5 fill-current" data-id="element-241" />
              Recomendado
            </div>

            <div className="inline-flex items-center gap-2 bg-teal-400/20 border border-teal-400/30 text-teal-300 font-bold px-3 py-1 rounded-full text-xs mb-4 uppercase tracking-wide" data-id="element-242">
              <CheckCircle2 className="w-3.5 h-3.5" data-id="element-243" />
              Si tenés el Pack Completo
            </div>
            <h3 className="text-xl font-bold text-white mb-5" data-id="element-244">
              El sistema más completo para transformar tu cuerpo y mente
            </h3>

            <div className="space-y-5" data-id="element-245">
              {[{
              title: 'Todo el contenido del Sistema Tai Chi Liviano',
              subs: []
            }, {
              title: 'Bono Exclusivo: Meditación PRO',
              subs: ['Estrategias para calmar la mente rápidamente', 'Plan de meditación de 30 días', 'Hábitos que favorecen un mejor descanso']
            }, {
              title: 'Bono Exclusivo: Nutrición Antiinflamatoria',
              subs: ['Guía para reducir la inflamación abdominal', 'Hábitos y nutrición para el cuidado articular', 'Plan práctico de comidas semanales']
            }, {
              title: 'Bono Exclusivo: Flexibilidad Avanzada',
              subs: ['Estiramientos que potencian tu movilidad', 'Técnicas para mejorar la postura diaria', 'Recursos para recuperar agilidad']
            }, {
              title: 'Acceso a futuras actualizaciones premium',
              subs: []
            }].map((item, i) => <div key={i} data-id="element-246">
                  <div className="flex items-start gap-3" data-id="element-247">
                    <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" data-id="element-248" />
                    <span className="text-white font-semibold" data-id="element-249">
                      {item.title}
                    </span>
                  </div>
                  {item.subs.length > 0 && <ul className="mt-2 ml-8 space-y-1.5" data-id="element-250">
                      {item.subs.map((sub, j) => <li key={j} className="text-sm text-emerald-200/80 flex items-start gap-2" data-id="element-251">
                          <span className="text-teal-400 mt-1.5 w-1 h-1 rounded-full bg-teal-400 flex-shrink-0" data-id="element-252" />
                          {sub}
                        </li>)}
                    </ul>}
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* 9. GARANTÍA */}
      <section className="py-12 px-4 bg-amber-50" data-id="element-253">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-254">
          <div className="bg-amber-100 p-6 rounded-full text-amber-600 flex-shrink-0" data-id="element-255">
            <ShieldCheck className="w-16 h-16" data-id="element-256" />
          </div>
          <div data-id="element-257">
            <h2 className="text-2xl md:text-3xl font-bold text-emerald-950 mb-2" data-id="element-258">
              Garantía de 7 Días
            </h2>
            <p className="text-lg text-gray-700" data-id="element-259">
              Estamos tan seguros de que este sistema funciona que te damos 7
              días para probarlo.
              <strong className="text-emerald-800" data-id="element-260">
                {' '}
                Si no estás conforme, te devolvemos el 100% de tu dinero.
              </strong>{' '}
              Sin preguntas.
            </p>
          </div>
        </div>
      </section>

      {/* 10. FAQ */}
      <section className="py-14 px-4 bg-white" data-id="element-261">
        <div className="max-w-3xl mx-auto" data-id="element-262">
          <h2 className="text-3xl font-bold text-emerald-950 text-center mb-8" data-id="element-263">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-2" data-id="element-264">
            <FAQItem question="¿Funciona si nunca hice ejercicio o Tai Chi?" answer="Sí, está diseñado desde cero. Los movimientos son muy suaves, guiados paso a paso y pensados para personas de cualquier edad y condición física." data-id="element-265" />
            <FAQItem question="¿Seguro que no me van a doler las rodillas?" answer="100% seguro. Al realizarse completamente sentado en una silla, no hay ningún tipo de impacto en tus rodillas, tobillos ni articulaciones." data-id="element-266" />
            <FAQItem question="¿Cómo recibo el producto?" answer="Es un producto 100% digital. Inmediatamente después de tu compra, vas a recibir un email con tus datos de acceso a la plataforma donde podrás ver y descargar todo el material." data-id="element-267" />
            <FAQItem question="¿Necesito algún equipo especial?" answer="¡Para nada! Solo necesitás una silla cómoda, ropa suelta y unos minutos al día. No tenés que comprar pesas ni accesorios." data-id="element-268" />
          </div>
        </div>
      </section>

      {/* 11. CTA FINAL */}
      <section className="py-16 px-4 bg-emerald-900 text-center" data-id="element-269">
        <div className="max-w-3xl mx-auto" data-id="element-270">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-271">
            Es momento de transformar tu cuerpo y tu vida
          </h2>
          <p className="text-xl text-emerald-100 mb-8" data-id="element-272">
            No dejes pasar más tiempo. Empezá hoy mismo tu transformación desde
            la comodidad de tu silla.
          </p>
          <CTAButton text="Quiero mi Sistema Tai Chi Liviano" className="text-2xl px-12 py-6 mx-auto" data-id="element-273" />
          <p className="mt-6 text-emerald-300 text-sm" data-id="element-274">
            Oferta válida por tiempo limitado. Acceso inmediato.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-emerald-950 text-emerald-400/60 py-8 text-center text-sm" data-id="element-275">
        <p data-id="element-276">
          © {new Date().getFullYear()} Sistema Tai Chi Liviano. Todos los
          derechos reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4" data-id="element-277">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}